import React from "react";
import ImplicitConsent from "./implicit-consent.js";
const ImplicitConsents = ({ documents }) => {
  if (!documents.length) {
    return null;
  }
  return /* @__PURE__ */ React.createElement("div", { className: "gl-vspace-bpall-small", "data-auto-id": "implicit-consents" }, documents.map((doc) => /* @__PURE__ */ React.createElement(ImplicitConsent, { key: doc.document.documentName, document: doc })));
};
export {
  ImplicitConsents as default
};
//# sourceMappingURL=implicit-consents.js.map
